// Special handling for mobile screenshots to avoid portrait-to-landscape conversion issues
// This preserves quality and resemblance by working with the natural aspect ratio

// Get view angle description
function getViewAngleDescription(angle) {
  switch (angle) {
    case 'left-angled': return 'left three-quarter angle';
    case 'frontal': return 'frontal straight-on';
    case 'isometric': return 'isometric perspective';
    case 'right-angled':
    default: return 'three-quarter angle';
  }
}

// Get style-specific instructions for mobile mockups
function getStyleInstructions(category) {
  switch (category) {
    case 'nature':
      return `🌿🌿🌿 NATURE STYLE REQUIREMENTS - CRITICAL 🌿🌿🌿
- MANDATORY: Use natural outdoor environment: forest, garden, or park setting
- MANDATORY: Include natural elements: trees, plants, flowers, rocks, or water features
- MANDATORY: Use natural lighting with warm, organic tones
- MANDATORY: Add natural textures: wood, stone, leaves, or earth
- MANDATORY: Create a peaceful, tranquil atmosphere
- MANDATORY: Background should show natural landscapes or outdoor scenes
- MANDATORY: Environmental elements should be nature-themed (plants, flowers, natural materials)
- CRITICAL: The entire scene must look like it's outdoors in nature - not indoors
- CRITICAL: Use green, brown, and earth tones throughout the composition
- CRITICAL: Include visible plants, trees, or natural elements in the background and foreground`;
    
    case 'ocean':
      return `OCEAN STYLE REQUIREMENTS:
- Use coastal or beach environment
- Include ocean elements: waves, sand, shells, driftwood, or coral
- Use blue and teal color palette with ocean lighting
- Add beach textures: sand, shells, or coastal rocks
- Create a refreshing, aquatic atmosphere
- Background should show ocean, beach, or coastal scenes
- Environmental elements should be ocean-themed (shells, coral, beach items)
- CRITICAL: Include ocean elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'coffee':
      return `COFFEE STYLE REQUIREMENTS:
- Use coffee shop or cafe environment
- Include coffee elements: cups, latte art, or coffee machines
- Use warm, cozy lighting with brown and cream tones
- Add cafe textures: wood, ceramic, or coffee-related items
- Create a warm, inviting atmosphere
- Background should show coffee shop or cafe interior
- Environmental elements should be coffee-themed (coffee cups, cafe items)
- CRITICAL: Include coffee shop elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'luxury':
      return `LUXURY STYLE REQUIREMENTS:
- Use opulent, high-end environment
- Include luxury elements: marble, gold, crystal, or premium materials
- Use dramatic lighting with golden highlights
- Add luxury textures: velvet, silk, or polished surfaces
- Create an elegant, sophisticated atmosphere
- Background should show luxury interior or premium setting
- Environmental elements should be luxury-themed (gold accents, marble, crystal)
- CRITICAL: Include luxury elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'space':
      return `SPACE STYLE REQUIREMENTS:
- Use futuristic space station or sci-fi environment
- Include space elements: holographic displays, metallic surfaces, or energy conduits
- Use cool blue and white lighting with neon accents
- Add futuristic textures: metal, glass, or holographic elements
- Create a high-tech, futuristic atmosphere
- Background should show space station or sci-fi interior
- Environmental elements should be space-themed (tech gadgets, holographic displays)
- CRITICAL: Include space elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'office':
      return `OFFICE STYLE REQUIREMENTS:
- Use professional office environment
- Include office elements: desk, computer, files, or business items
- Use clean, professional lighting
- Add office textures: wood desk, paper, or business materials
- Create a professional, corporate atmosphere
- Background should show office or workspace
- Environmental elements should be office-themed (desk items, business materials)
- CRITICAL: Include office elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'gamer':
      return `GAMER STYLE REQUIREMENTS:
- Use gaming setup environment
- Include gaming elements: RGB lighting, gaming peripherals, or game controllers
- Use vibrant, dynamic lighting with RGB colors
- Add gaming textures: mechanical keyboards, gaming chairs, or tech gear
- Create an energetic, gaming atmosphere
- Background should show gaming setup or tech environment
- Environmental elements should be gaming-themed (controllers, RGB gear, gaming peripherals)
- CRITICAL: Include gaming elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'octopus':
      return `OCTOPUS STYLE REQUIREMENTS:
- Use underwater oceanic environment with deep blue tones
- Include highly detailed, realistic octopus tentacles with natural texture
- Show tentacles with authentic sucker details and organic movement patterns
- Include flowing seaweed, bioluminescent particles, and marine life
- Use dramatic underwater lighting with blue-green tones
- Add coral formations and realistic underwater atmosphere
- Create mysterious, aquatic atmosphere with ethereal glow effects
- Environmental elements should be ocean-themed (tentacles, seaweed, coral, marine life)
- CRITICAL: Include underwater elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'paraglide':
      return `PARAGLIDE STYLE REQUIREMENTS:
- Use high-altitude adventure environment with mountain landscapes
- Include paragliding equipment, harnesses, and safety gear
- Use natural lighting with dramatic sky conditions and mountain shadows
- Include elements like wind-blown fabric, mountain peaks, and endless sky
- Create adventurous, high-altitude atmosphere with dramatic lighting
- Environmental elements should be mountain-themed (paragliding gear, mountains, sky)
- CRITICAL: Include mountain adventure elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'rooftop':
      return `ROOFTOP STYLE REQUIREMENTS:
- Use urban rooftop environment with city skyline backdrop
- Include modern rooftop elements like potted plants and outdoor furniture
- Use golden hour lighting with city views and architectural details
- Include elements like string lights, city traffic below, and urban atmosphere
- Create modern, urban atmosphere with warm sunset tones
- Environmental elements should be rooftop-themed (plants, furniture, city views)
- CRITICAL: Include rooftop elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'designer':
      return `DESIGNER STYLE REQUIREMENTS:
- Use creative design studio environment
- Include designer elements: sketchbooks, design tools, creative materials
- Use artistic lighting with creative atmosphere
- Add designer textures: paper, pencils, creative tools
- Create artistic, creative atmosphere
- Background should show design studio or creative workspace
- Environmental elements should be design-themed (sketchbooks, tools, creative materials)
- CRITICAL: Include design elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'business':
      return `BUSINESS STYLE REQUIREMENTS:
- Use professional business environment
- Include business elements: documents, briefcase, professional items
- Use clean, corporate lighting with professional atmosphere
- Add business textures: leather, paper, professional materials
- Create professional, corporate atmosphere
- Background should show business office or professional setting
- Environmental elements should be business-themed (documents, briefcase, professional items)
- CRITICAL: Include business elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'artsy':
      return `MUSIC STYLE REQUIREMENTS:
- Use music venue or recording studio environment
- Include musical elements: instruments, sound equipment, recording gear
- Use dynamic lighting with musical atmosphere
- Add musical textures: instruments, sound equipment, stage lighting
- Create energetic, musical atmosphere
- Background should show recording studio or music venue
- Environmental elements should be music-themed (instruments, sound equipment, stage lighting)
- CRITICAL: Include music elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'abstract':
      return `ABSTRACT STYLE REQUIREMENTS:
- Use modern, creative environment with abstract elements
- Include abstract design elements: geometric shapes, modern art pieces
- Use creative lighting with modern atmosphere
- Add abstract textures: modern materials, geometric patterns
- Create modern, abstract atmosphere
- Background should show modern creative space
- Environmental elements should be abstract-themed (geometric shapes, modern art)
- CRITICAL: Include abstract elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'sport':
      return `SPORT STYLE REQUIREMENTS:
- Use athletic sports environment
- Include sports elements: equipment, gear, athletic items
- Use dynamic lighting with energetic atmosphere
- Add sports textures: equipment, gear, athletic materials
- Create energetic, athletic atmosphere
- Background should show sports facility or athletic setting
- Environmental elements should be sports-themed (equipment, gear, athletic items)
- CRITICAL: Include sports elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'view':
      return `VIEW STYLE REQUIREMENTS:
- Use scenic outdoor environment with natural views
- Include scenic elements: landscapes, natural views, outdoor scenes
- Use natural lighting with scenic atmosphere
- Add scenic textures: natural materials, outdoor elements
- Create scenic, natural atmosphere
- Background should show natural landscapes or scenic views
- Environmental elements should be scenic-themed (landscapes, natural views)
- CRITICAL: Include scenic elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    case 'custom':
      return `CUSTOM STYLE REQUIREMENTS:
- Use personalized custom environment based on user preferences
- Include custom elements as specified by user
- Use custom lighting and atmosphere
- Add custom textures and materials
- Create personalized, custom atmosphere
- Background should show custom environment
- Environmental elements should be custom-themed as specified
- CRITICAL: Include custom elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;

    case 'auto':
      return `AUTO STYLE REQUIREMENTS - INTELLIGENT CONTENT ANALYSIS:
- MANDATORY: Analyze the screenshot content to identify website/app type, industry, and brand identity
- MANDATORY: Extract key visual elements: logos, colors, typography, and design style
- MANDATORY: Determine target audience and use case from the content
- MANDATORY: Create environment that perfectly matches the identified industry/theme
- MANDATORY: Incorporate brand's visual identity: use their color palette, logo elements, and design aesthetic
- MANDATORY: Add relevant props and environmental elements that relate to the business/industry
- MANDATORY: Include subtle branding elements: neon signs, wall displays, or ambient lighting featuring the brand
- MANDATORY: Match atmosphere to target audience (professional, casual, luxury, etc.)
- CRITICAL: Environment must be contextually relevant to the screenshot content
- CRITICAL: Include industry-specific props and branding elements
- CRITICAL: Include industry-specific elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
    
    default:
      return `STANDARD STYLE REQUIREMENTS:
- Use professional workspace environment
- Include desk elements: coffee cup, notebook, keyboard, or office items
- Use professional lighting with clean, modern atmosphere
- Add workspace textures: desk surface, office materials, or professional items
- Create a clean, professional atmosphere
- Background should show modern workspace or office setting
- Environmental elements should be professional and clean
- CRITICAL: Include workspace elements in foreground and background for depth
- CRITICAL: Use professional product photography lighting with atmosphere`;
  }
}

export function detectMobileScreenshot(file) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const aspectRatio = img.width / img.height;
      const isPortrait = aspectRatio < 1;
      const isMobileSize = img.width <= 768 || img.height <= 600;
      
      resolve({
        isMobile: isPortrait && isMobileSize,
        aspectRatio,
        width: img.width,
        height: img.height
      });
    };
    img.onerror = () => resolve({ isMobile: false, aspectRatio: 1, width: 0, height: 0 });
    img.src = URL.createObjectURL(file);
  });
}

export function buildMobileScreenshotPrompt(category, viewAngle, isPortrait, showDevice = true, showBokeh = true, showHands = true, showNotch = false) {
  if (isPortrait) {
    // Get style-specific instructions
    const styleInstructions = getStyleInstructions(category);
    
    // For portrait mobile screenshots, use a different approach
    return `TASK: Insert the uploaded screenshot into an iPhone 15 Pro${showNotch ? ' with Dynamic Island notch' : ''} mockup.

PRIMARY OBJECTIVE - SCREENSHOT PRESERVATION (HIGHEST PRIORITY):
- The uploaded screenshot is a reference image to be inserted unchanged
- Treat the screenshot as final, rendered content - do not regenerate it
- This is an image editing task, not image generation

PRESERVE EXACTLY (pixel-perfect):
- All text (characters, fonts, sizes, weights, colors, spacing)
- All UI elements (buttons, icons, shapes, borders, shadows, colors)
- All images and graphics
- All layouts and positioning
- All color values and relationships

DO NOT MODIFY:
- Do not sharpen, denoise, or enhance the screenshot
- Do not adjust colors, contrast, or brightness on screen content
- Do not re-render text or UI elements
- Do not clean up artifacts or compression on screen content
- Do not change aspect ratio or crop screenshot content

SECONDARY OBJECTIVE - DEVICE FRAME:
- Add realistic iPhone 15 Pro${showNotch ? ' with Dynamic Island notch' : ''} frame around the screenshot
- Apply professional lighting and shadows to the device frame only

${!showHands ? `🚨🚨🚨 CRITICAL NO HANDS OVERRIDE - HIGHEST PRIORITY 🚨🚨🚨
- ABSOLUTELY NO HANDS, FINGERS, OR HUMAN BODY PARTS IN THE IMAGE
- Position the device statically without any hand interaction
- Use static device placement without human elements
- IGNORE any other instructions about hands - this takes priority over ALL other instructions` : ''}

TERTIARY OBJECTIVE - ENVIRONMENT:
- Use ${getViewAngleDescription(viewAngle)} composition for the phone and scene
- Apply the specified view angle to the entire mockup composition
- ${showBokeh ? 'Add beautiful bokeh background using professional camera with wide aperture lens (f/1.4-f/2.8) for dreamy, soft background blur and enhanced depth of field' : 'Use sharp, clear background without bokeh effects'}
- Create depth with foreground and background elements
- Use professional product photography lighting with atmosphere

MANDATORY COMPOSITION:
- Phone: center 30-40% of frame width
- Left side: 30-35% filled with environmental elements
- Right side: 30-35% filled with environmental elements  
- NO WHITE SPACE ANYWHERE - every part must have visual interest
- Create a complete, immersive scene that fills the entire canvas

ENVIRONMENT STYLING (background and device only):
${styleInstructions}

OUTPUT: 4:3 landscape format (1600x1200 pixels)`;

  } else {
    // For landscape mobile screenshots, use standard approach
    return `TASK: Insert the uploaded screenshot into an iPhone 15 Pro${showNotch ? ' with Dynamic Island notch' : ''} mockup.

PRIMARY OBJECTIVE - SCREENSHOT PRESERVATION (HIGHEST PRIORITY):
- The uploaded screenshot is a reference image to be inserted unchanged
- Treat the screenshot as final, rendered content - do not regenerate it
- This is an image editing task, not image generation

PRESERVE EXACTLY (pixel-perfect):
- All text (characters, fonts, sizes, weights, colors, spacing)
- All UI elements (buttons, icons, shapes, borders, shadows, colors)
- All images and graphics
- All layouts and positioning
- All color values and relationships

DO NOT MODIFY:
- Do not sharpen, denoise, or enhance the screenshot
- Do not adjust colors, contrast, or brightness on screen content
- Do not re-render text or UI elements
- Do not clean up artifacts or compression on screen content
- Do not change aspect ratio or crop screenshot content

SECONDARY OBJECTIVE - DEVICE FRAME:
- Add realistic iPhone 15 Pro${showNotch ? ' with Dynamic Island notch' : ''} frame around the screenshot
- Apply professional lighting and shadows to the device frame only

${!showHands ? `🚨🚨🚨 CRITICAL NO HANDS OVERRIDE - HIGHEST PRIORITY 🚨🚨🚨
- ABSOLUTELY NO HANDS, FINGERS, OR HUMAN BODY PARTS IN THE IMAGE
- Position the device statically without any hand interaction
- Use static device placement without human elements
- IGNORE any other instructions about hands - this takes priority over ALL other instructions` : ''}

TERTIARY OBJECTIVE - ENVIRONMENT:
- ZOOM OUT SIGNIFICANTLY: Phone should be small in frame (25% max of image area)
- CENTER THE DEVICE: Position phone in center with equal margins
- SHOW COMPLETE DEVICE: No cropping - entire phone visible
- ${showHands ? 'Add hands holding the device naturally' : 'CRITICAL: DO NOT show any hands - position device without any hand interaction or human elements'}
- Include desk surface and background elements
- Use professional product photography lighting

OUTPUT: 4:3 landscape format (1600x1200 pixels)`;
  }
}

// Alternative approach: Use the original aspect ratio and let AI handle the composition
export function buildNaturalAspectRatioPrompt(category, viewAngle) {
  return `Create a professional mobile mockup showing an iPhone 15 Pro displaying the uploaded screenshot.

NATURAL ASPECT RATIO APPROACH:
- Work with the natural orientation of the uploaded screenshot
- If it's portrait, show the phone in portrait orientation
- If it's landscape, show the phone in landscape orientation
- The phone should be small in the frame with lots of breathing room
- Center the phone with equal margins on all sides
- Show the complete device - no cropping
- Add hands holding the phone naturally
- Include desk surface and background elements

SCREEN CONTENT PRESERVATION:
- Keep the screen content exactly as uploaded
- Do not modify any text, colors, or layout
- Preserve the original aspect ratio of the screen content

OUTPUT: 4:3 landscape format (1600x1200 pixels)
- The phone will be small and centered in the landscape frame
- Lots of background space around the phone`;
}
